import Vue from 'vue';

// initial state
const state = {
    allPackages: [],
    package: null
}

// getters
const getters = {
    allPackages: state => state.allPackages,
    allPackagesByIds(state) {
        return ids => {
            console.log('ids allPackagesByIds', ids)
            console.log('state allPackagesByIds', state)
            const packages = ids.map(id => state.allPackages.find(p => p.value.id == id).value)
            console.log('packages allPackagesByIds', packages)
            return packages
        }
    }
}

// mutations
const mutations = {
    setPackages(state, packages) {
        state.allPackages = packages
    }
}

// actions
const actions = {
    getPackagesById: function (context, id) {
        return Vue.http.get(wwfconfigs.CLOUDFUNCTION + '/' + 'getPackagesById?packageId=' + id).then(response => response.body);
    },
    savePackageById: function (context, data) {
        console.log("context", context);
        console.log("id", data.id);
        console.log("package", data.package);
        console.log("this.state", this.state);

        return Vue.http.post(wwfconfigs.CLOUDFUNCTION + '/' + 'savePackage', data);
    },
    getAllPackages: function (context) {
        console.log('getAllPackages')
        Vue.http.get(wwfconfigs.CLOUDFUNCTION + '/' + 'getPackages').then(response => {
            context.commit('setPackages', response.body);
        });
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/packages.js